import 'reflect-metadata';
import {jsonObject, jsonMember, jsonMapMember} from 'typedjson';
import {Serializers} from '@/utils/Serializers';

import {OpenVpnSettings} from '@/model/network/settings/OpenVpnSettings';

export enum VpnServiceType {
  OpenVpn = 'org.freedesktop.NetworkManager.openvpn',
}

export const VpnServiceTypeLabels = [VpnServiceType.OpenVpn, 'OpenVPN'];

@jsonObject({
  typeResolver: VpnSettings.TypeResolver,
})
export class VpnSettings {

  public static TypeResolver(vpnSettings: any, knownTypes: Map<string, Function>) {
    switch (vpnSettings.serviceType) {
      case VpnServiceType.OpenVpn:
        return knownTypes.get('OpenVpnSettings');

      default:
        return knownTypes.get('VpnSettings');
    }
  }

  @jsonMapMember(String, String, {
    name: 'data',
    deserializer: Serializers.ObjectToMap,
    serializer: Serializers.MapToObject,
  })
  public Data!: Map<string, string>;

  @jsonMember({name: 'persistent'})
  public Persistent!: boolean;

  @jsonMapMember(String, String, {
    name: 'secrets',
    deserializer: Serializers.ObjectToMap,
    serializer: Serializers.MapToObject,
  })
  public Secrets!: Map<string, string>;

  @jsonMember({name: 'serviceType'})
  public ServiceType!: string;

  @jsonMember({name: 'timeout'})
  public Timeout!: number;

  @jsonMember({name: 'userName'})
  public UserName!: string;

  constructor(vpnSettings?: Partial<VpnSettings>) {
    if (vpnSettings) {
      Object.assign(this, vpnSettings);

      if (vpnSettings.Data) {
        this.Data = new Map(vpnSettings.Data);
      }

      if (vpnSettings.Secrets) {
        this.Secrets = new Map(vpnSettings.Secrets);
      }
    }
  }

  public get Name(): string {
    return 'Unknown';
  }
}
